namespace SorAraBul.PropertyManagement {
    export namespace FormWizardService {
        export const baseUrl = 'PropertyManagement/CompanyFormData';


        export declare const enum Methods {

        }

    }
}
